import Order from "./Order";
import Product from "./Product";
import InsulationCut from "./InsulationCut";
import BaseModel from "./BaseModel";

export default class OrderItem extends BaseModel {

	static entity = 'order_items';
	static route = 'order-items';
	static plural = 'order_items';
	static singular = 'order_item';

	static fields () {
		return {
			id: this.attr(null),
			order_id: this.attr(null),
			order: this.belongsTo(Order, 'order_id'),
			product_id: this.attr(null),
			product: this.belongsTo(Product, 'product_id'),
			insulation_cut_id: this.attr(null),
			insulation_cut: this.belongsTo(InsulationCut, 'insulation_cut_id'),
			quantity: this.attr(null),
			drop: this.attr(null),
			fill: this.attr(null),
			description: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null)
		}
	}

	static parseFilteredName(product, insulation_cut, description) {
		if(insulation_cut && product && product.name !== 'Other') {
			return [
				product instanceof Product ? product.getFilteredName() : Product.parseFilteredName(product.name), 
				insulation_cut instanceof InsulationCut ? insulation_cut.getFilteredName() : InsulationCut.parseFilteredName(insulation_cut.thickness, insulation_cut.thickness_unit, insulation_cut.width, insulation_cut.width_unit, insulation_cut.length, insulation_cut.length_unit)
			].join(' - ');
		} else if(product && product.name !== 'Other') {
			return product instanceof Product ? product.getFilteredName() : Product.parseFilteredName(product.name);
		}
		return OrderItem.decodeHTMLEntities(description);
	}

	getFilteredName() {
		return OrderItem.parseFilteredName(this.product, this.insulation_cut, this.description);
	}

}
